import type { Profile } from '@/types';

const now = new Date().toISOString();

export const mockProfiles: Profile[] = [
  {
    id: 'p_doctor_1',
    authUserId: 'auth_doctor_1',
    email: 'sarah.chen@example.com',
    firstName: 'Sarah',
    surname: 'Chen',
    phone: '+61 412 345 678',
    avatarUrl: null,
    role: 'doctor',
    status: 'active',
    lastLoginAt: now,
    createdAt: '2025-01-12T10:21:00Z',
    updatedAt: now,
  },
  {
    id: 'p_doctor_2',
    authUserId: 'auth_doctor_2',
    email: 'james.okafor@example.com',
    firstName: 'James',
    surname: 'Okafor',
    phone: '+61 413 222 901',
    avatarUrl: null,
    role: 'doctor',
    status: 'active',
    lastLoginAt: '2026-04-29T08:14:00Z',
    createdAt: '2024-09-04T08:00:00Z',
    updatedAt: now,
  },
  {
    id: 'p_admin_1',
    authUserId: 'auth_admin_1',
    email: 'priya.kumar@locumnetwork.com.au',
    firstName: 'Priya',
    surname: 'Kumar',
    phone: '+61 411 555 600',
    avatarUrl: null,
    role: 'admin',
    status: 'active',
    lastLoginAt: now,
    createdAt: '2024-06-01T09:00:00Z',
    updatedAt: now,
  },
  {
    id: 'p_compliance_1',
    authUserId: 'auth_compliance_1',
    email: 'mark.dunlop@locumnetwork.com.au',
    firstName: 'Mark',
    surname: 'Dunlop',
    role: 'compliance_admin',
    status: 'active',
    lastLoginAt: now,
    createdAt: '2024-07-15T09:00:00Z',
    updatedAt: now,
  },
  {
    id: 'p_recruiter_1',
    authUserId: 'auth_recruiter_1',
    email: 'lena.park@locumnetwork.com.au',
    firstName: 'Lena',
    surname: 'Park',
    role: 'recruiter',
    status: 'active',
    lastLoginAt: now,
    createdAt: '2024-08-22T09:00:00Z',
    updatedAt: now,
  },
  {
    id: 'p_super_1',
    authUserId: 'auth_super_1',
    email: 'admin@locumnetwork.com.au',
    firstName: 'Operations',
    surname: 'Lead',
    role: 'super_admin',
    status: 'active',
    lastLoginAt: now,
    createdAt: '2024-05-10T09:00:00Z',
    updatedAt: now,
  },
];
